module.exports = __webpack_public_path__ + "img/flow_icon02.06cf4855.png";